export default __webpack_public_path__ + "static/media/csco.d232a46a.jfif";